<template>
  <div class="drboxes">
    <drag-modal :visible="tabVisible" title="待办事项" width='920px' class="disform" @cancel='tabVisible=false;tableList=[];tableData={};' :zIndex="1002">
      <table class="table">
        <thead>
          <td width="140">提醒时间</td>  
          <td width="60">标题</td>
          <td width="240">提醒内容</td>
          <td width="140">创建时间</td>
          <td width="50">状态</td>
          <td  width="100">操作</td>
        </thead>
        <tbody>
          <tr v-for="i in tableList" :class="{'err':i.is_complete==0}">
            <td>{{ i.remind_time }}</td>
            <td>
              <div><Normap :tit="i.title"></Normap></div>
            </td>
            <td>
              <div><Normap :tit="i.content"></Normap></div>
            </td>
            <td>{{ i.create_time }}</td>
            <td >
              {{ i.is_complete==1?'已完成':'未完成' }}
            </td>
            <td>
              <a href="javascript:void(0);" @click="see(i.id,2)"  v-if="i.is_complete==0">修改</a>
              <a href="javascript:void(0);" @click="isok(i.id)" style="margin-left:10px;" v-if="i.is_complete==0">完成</a>
            </td>
          </tr>
        </tbody>
      </table>
    </drag-modal>
    <drag-modal :visible="putVisible" :title='edit==0?"查看":(edit==1?"新增":"编辑")' width='410px' class="disform" @cancel='rest'  :zIndex="1003">
      <a-form-model ref="forms" :rules="rules" :model="form" :label-col="{span: 5}" :wrapper-col="{span:18 }">
        <a-form-model-item label="标题" prop="title" :rules="{ required: true, message: '请输入标题',trigger: 'blur'}">
          <a-input v-model="form.title" placeholder="请输入" :disabled='edit==0' />
        </a-form-model-item>
        <a-form-model-item label="待办内容" prop="content" :rules="{ required: true, message: '请输入待办内容',trigger: 'blur'}">
          <Ntxt :content='form.content' :max='1000' Hei='108px' @contentVal='(e)=>{form.content=e}' :edit='edit==0'></Ntxt>
        </a-form-model-item>
        <a-form-model-item label="提醒时间" prop="remind_time" :rules="{ required: true, message: '请选择提醒时间',trigger: 'change'}">
          <a-date-picker v-model="form.remind_time" placeholder="请选择" show-time style="width: 100%;" type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm:ss' :disabled='edit==0' />
        </a-form-model-item>
        <a-form-model-item v-if='edit!=0'>
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a-button type="primary" style="width: 133px;height: 32px;margin:0 0 0 80px;">
              确定
            </a-button>
          </a-popconfirm>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
    <drag-modal :visible="visible" title='待办事项' width='720px' class="disform" @cancel='visible=false;'>
      <div class="intopbtn">
        <a-button type="primary"  size="small"  style="height:34px" @click="edit=1;putVisible=true">新增待办</a-button>
      </div>
      <div class="desktop-calendar">
        <div class="header">
          <div class="btn" @click="previousMonth">
            <a-icon type="left" />
          </div>
          <div class="datebox">
            <div class="date">
              <!-- <input v-model="inputYear" type="number" placeholder="Year"  /> -->
              {{ inputYear }}  年
            </div>
            <div  class="date">
              {{ inputMonth }} 月
            </div>
          
          </div>
          <div class="btn" @click="nextMonth">
              <a-icon type="right" />
            </div>
        </div>
        <div class="days">
          <div v-for="day in daysOfWeek"  class="day" style="height:30px;">{{ day }}</div>
          <div v-for="blankDay in leadingBlanks" :key="blankDay" class="empty"></div>
          <div v-for="date in daysInMonth" class="day" :class="{ today: isToday(date) }">
            <div class="tp">
              {{inputMonth}} / {{ date }} 
            </div>
            <div class="list" v-if="groupedByDate[rtime(date)]">
                <div class="li" v-for="(i,index) in groupedByDate[rtime(date)]" :class="{'over':i.is_complete==1}" @click="outCk(i)">{{ i.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </drag-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Ntxt from '@/components/textarea/ntxt'
import { todoAdd, todoInfo, todoUpdate, todoOk } from '@/server/api'
function getDateFromTimeString(timeString) {
  const date = new Date(timeString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 月份从 0 开始，所以要加 1
  const day = date.getDate();
  return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
}

function groupByDate(dataArray) {
  const groupedData = {};

  dataArray.forEach(item => {
    const createDate = getDateFromTimeString(item.remind_time);
    if (!groupedData[createDate]) {
      groupedData[createDate] = [];
    }
    groupedData[createDate].push(item);
  });

  return groupedData;
}
function formatDate(year, month,date) {
  return `${year}-${month < 10 ? '0' + month : month}-${date < 10 ? '0' + date : date}`;
}
export default {
  components:{Ntxt},
  data() {
    return {
      tabVisible:false,
      putVisible:false,
      tableList:[],
      edit:0,
      visible:false,
      currentMonth: moment(),
      rules:{},
      form: {
        content: '',
        title: ''
      },
      tableData:{},
      groupedByDate:{},
      inputYear: moment().year(),
      inputMonth: moment().month() + 1,
    };
  },
  computed: {
    daysOfWeek() {
      return moment.weekdaysShort();
    },
    daysInMonth() {
      const days = [];
      const firstDay = moment(`${this.inputYear}-${this.inputMonth}-01`, 'YYYY-MM-DD').startOf('month');
      const lastDay = moment(`${this.inputYear}-${this.inputMonth}-01`, 'YYYY-MM-DD').endOf('month');

      for (let date = moment(firstDay); date.isSameOrBefore(lastDay); date.add(1, 'day')) {
        days.push(date.format('D'));
      }

      return days;
    },
    leadingBlanks() {
      const firstDayOfMonth = moment(`${this.inputYear}-${this.inputMonth}-01`, 'YYYY-MM-DD').startOf('month');
      return Array.from({ length: firstDayOfMonth.day() }, (_, index) => index);
    },
  },
  watch: {
    inputYear: 'validateInput',
    inputMonth: 'validateInput',
  },
  created(){
   // this.init()
  },
  methods: {
    isok(id) {
      todoOk({ id: id }).then(e => {
        this.$message.success('已标记完成')
        this.rest()
        this.init()
        this.tabVisible=false;
      })
    },
    see(id, type) {
      this.edit = type;
      todoInfo({ id: id }, 0).then(e => {
        this.form = {
            id: e.id,
            title: e.title,
            content: e.content,
            remind_time: e.remind_time
        }
        this.putVisible = true
      })
    },
    confirm() {
      let form = JSON.parse(JSON.stringify(this.form))
      let disform = {
        title: form.title,
        content: form.content,
        remind_time: form.remind_time
      }
      this.$refs.forms.validate(valid => {
        if (valid) {
          if (this.edit == 1) {
            todoAdd(disform, 1).then(e => {
              this.$message.success('新增成功')
              this.init()
              this.rest()
            })
          }
          else {
            disform.id = form.id
            todoUpdate(disform, 1).then(e => {
              this.$message.success('编辑成功')
              this.init()
              this.rest()
              this.getTableList(this.tableData)
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    rtime(date){
      return formatDate(this.inputYear,this.inputMonth,date)
    },
    rest() {
      let form = JSON.parse(JSON.stringify(this.form))
      for (let val in form) {
        form[val] = ''
      }
      this.form = form
      this.putVisible=false;
    },
    init(){
      const yearM=this.inputYear+'-'+this.inputMonth
      const data={
        start_date:yearM+"-01",
        end_date:yearM+'-'+moment(yearM).endOf('month').format('DD'),
        limit:100,
        page:1
      }
      this.$Ajax({
        url:'todo/index',
        data:data,
        type: "get",
      }).then(e=>{
        const groupedByDate = groupByDate(e.list);
        // console.log(groupedByDate)
        this.groupedByDate=groupedByDate
      })
    },
    previousMonth() {
      this.currentMonth.subtract(1, 'month');
      this.updateInputYearAndMonth();
     //this.init()
    },
    nextMonth() {
      this.currentMonth.add(1, 'month');
      this.updateInputYearAndMonth();
      
    },
    getTableList(data){
        this.$Ajax({
          url:'todo/index',
          data:data,
          type: "get",
        }).then(e=>{
            this.tabVisible=true;
            this.tableList=e.list;
        })
    },
    outCk(item){
      this.tableData={}
      if(item){
        this.tableData={
          start_date:moment(item.remind_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-M-D'),
          end_date:moment(item.remind_time, 'YYYY-MM-DD HH:mm:ss').format('YYYY-M-D'),
          limit:100,
          page:1
        }
        this.getTableList(this.tableData)
      }
    },
    validateInput() {
      if (this.inputYear < 1) {
        this.inputYear = 1;
      }
      if (this.inputMonth < 1) {
        this.inputMonth = 1;
      } else if (this.inputMonth > 12) {
        this.inputMonth = 12;
      }
      this.init()
    },
    updateInputYearAndMonth() {
      this.inputYear = this.currentMonth.year();
      this.inputMonth = this.currentMonth.month() + 1;
    },
    isToday(date) {
      return moment().isSame(this.currentMonth.clone().date(date), 'day');
    }
  }
}
</script>

<style lang="less" scoped>
.desktop-calendar {

}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  margin:0 auto 20px;
  .btn{
      font-size: 1.25rem;
      cursor: pointer;
    }
  .datebox{
    display: flex;
  
    .date{
      align-items: center;
      display: flex;
      input{
        margin:0 4px;
        width:100px;
        line-height: 30px;
        border:1px solid #ccc;
        border-radius:2px;
        text-align: center;
      }
    }
  }
}

.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
}

.day {
  padding-top:4px;
  text-align: center;
  height:6.5rem;
  border: 1px solid #ddd;
  cursor: pointer;
  transition-duration: 500ms;
  &:hover{
    border-color:#32c5e9;      
  }
  .tp{
    font-size: 0.75rem;
    color:#333;
    border-bottom: 1px solid #eee;
  }
  .list{
    overflow: hidden;
    height:74px;
    padding-top: 5px;
    .li{
      font-size: 0.75rem;
      overflow: hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      padding:0 4px;
      width:80px;
      font-weight: bold;
      color:#333;
      text-align: left;
      &::before{
        margin-right: 2px;
        display: inline-block;
        content:'';
        width:5px;
        height:5px;
        border-radius:50%;
        background: #32c5e9;
      }
    }
    .over{
      &::before{
        display: none;
      }
      color:#999;
      text-decoration: line-through;
    }
    .has{
      opacity: 1;
    }
  } 
}

.empty {
  visibility: hidden;
}

.today {
  border-color:#1d8bfe;
}
table{
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
  }
  .err{
    td{
      color:#f00;
    }
  }
</style>